// extracted by mini-css-extract-plugin
module.exports = {"image":"index-image-2sq0f"};